import { render, staticRenderFns } from "./CardContentLargeSize.vue?vue&type=template&id=c3acbb78&scoped=true&"
import script from "./CardContentLargeSize.vue?vue&type=script&lang=js&"
export * from "./CardContentLargeSize.vue?vue&type=script&lang=js&"
import style0 from "./CardContentLargeSize.vue?vue&type=style&index=0&id=c3acbb78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3acbb78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VImg,VTooltip})
